import React, { lazy, Suspense } from "react";
import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import "./App.less";

import PageLoading from "components/PageLoading";
import { getToken } from "utils/tokenManager";

const RegistrationLayout = lazy(() => import("layouts/RegistrationLayout"));
const AppLayout = lazy(() => import("layouts/AppLayout"));

const AntdConfig = {
  locale: zhCN,
};

function App() {
  return (
    <ConfigProvider {...AntdConfig}>
      <div className="App">
        <Router>
          <Suspense
            fallback={
              <div className="layout-loader">
                <PageLoading />
              </div>
            }
          >
            <Route
              exact
              path="/"
              render={() => {
                if (getToken()) {
                  if (window.location.pathname === "/")
                    return <Redirect to="/app" />;
                  else return <Redirect to={window.location.pathname} />;
                } else return <Redirect to="/registration/login" />;
              }}
            />
            <Route path="/registration" component={RegistrationLayout} />
            <Route path="/app" component={AppLayout} />
          </Suspense>
        </Router>
      </div>
    </ConfigProvider>
  );
}

export default App;
